import React from "react";
import PageTitleBox from "../../../common/PageTitleBox";
import { Divider, Paper } from "convertupleads-theme";
import DefaultSwitch from "./SwitchComponents/DefaultSwitch";
import SwitchSizes from "./SwitchComponents/SwitchSizes";
import SwitchColors from "./SwitchComponents/SwitchColors";
import SwitchWithLabel from "./SwitchComponents/SwitchWithLabel";
import SwitchWithLabelHelperText from "./SwitchComponents/SwitchWithLabelHelperText";
import AndriodSwitch from "./SwitchComponents/AndriodSwitch";
import AndriodSwitchWithIcon from "./SwitchComponents/AndriodSwitchWithIcon";
import OnOffSwitch from "./SwitchComponents/OnOffSwitch";
import CustomSwitchComponent from "./SwitchComponents/CustomSwitchComponent";

const SwitchPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Switch"}
        description={"Switches toggle the state of a single setting on or off."}
      />
      <Divider light />
      <DefaultSwitch />
      <SwitchSizes />
      <SwitchColors />
      <SwitchWithLabel />
      <SwitchWithLabelHelperText />
      <AndriodSwitch />
      <AndriodSwitchWithIcon />
      <OnOffSwitch />
      <CustomSwitchComponent />
    </Paper>
  );
};

export default SwitchPage;
